import { lazy } from 'react';
import { AlertTriangle, LayoutGrid, Mail, RectangleHorizontal } from 'lucide-react';
import type { ModuleDefinition } from '../types';

const OverviewPage = lazy(() => import('./pages/overview'));
const AlertsPage = lazy(() => import('./pages/alerts'));
const MailLogPage = lazy(() => import('./pages/mail-log'));
const FormsPage = lazy(() => import('./pages/forms'));

/**
 * The Monitor section: everything you look at when you want to know what is happening now.
 *
 * @since 1.0.0
 */
export const monitorModule: ModuleDefinition = {
    id: 'monitor',
    navSection: { label: 'Monitor', order: 1 },
    items: [
        {
            id: 'overview',
            label: 'Overview',
            icon: LayoutGrid,
            path: '/',
            title: 'Overview',
            actions: [
                { id: 'export', label: 'Export' },
                { id: 'run-all-checks', label: 'Run all checks', minRole: 'dev', variant: 'dark' },
            ],
        },
        {
            id: 'alerts',
            label: 'Alerts',
            icon: AlertTriangle,
            path: '/alerts',
            title: 'Alerts',
            badge: 'open-alerts',
            actions: [{ id: 'mute-rules', label: 'Mute rules', minRole: 'dev' }],
        },
        {
            id: 'mail',
            label: 'Mail log',
            icon: Mail,
            path: '/mail',
            title: 'Mail log',
            actions: [{ id: 'export-csv', label: 'Export CSV' }],
        },
        {
            id: 'forms',
            label: 'Forms',
            icon: RectangleHorizontal,
            path: '/forms',
            title: 'Forms',
            actions: [{ id: 'add-form', label: 'Add form', minRole: 'admin', variant: 'dark' }],
        },
    ],
    routes: [
        { path: '/', Component: OverviewPage },
        { path: '/alerts', Component: AlertsPage },
        { path: '/mail', Component: MailLogPage },
        { path: '/forms', Component: FormsPage },
    ],
};
